import { Box, Divider } from '@mui/material';
import { useTeamAvailability } from './hooks';
import { TeamAvailabilityHeader, UserEntry } from './components';
import { theme } from '@store';

export const TeamAvailability = () => {
  const { team } = useTeamAvailability();

  return (
    <>
      {team && (
        <Box
          sx={{
            minWidth: 354,
            maxWidth: 354,
            height: 'calc(100vh - 200px)',
            pointerEvents: 'all',
            bgcolor: 'white',
            display: 'flex',
            flexDirection: 'column',
            py: '1.5rem',
          }}
        >
          <TeamAvailabilityHeader
            color={team.color}
            teamName={team.name}
            activeCount={
              team.users.filter(user => user.activity_status !== 'offline')
                .length
            }
            totalCount={team.users.length}
          />

          {/* Body */}
          <Box
            sx={{
              width: '100%',
              height: '100%',
              overflowY: 'auto',
              display: 'flex',
              gap: '1rem',
              flexDirection: 'column',
              px: '1.5rem',
              '&::-webkit-scrollbar': {
                width: '6px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: 'transparent',
                borderRadius: '10px',
              },
              '&:hover::-webkit-scrollbar-thumb': {
                backgroundColor: 'rgba(0, 0, 0, 0.3)',
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: 'transparent',
              },
            }}
          >
            {team.users.map((entry, index) => (
              <Box
                sx={{
                  display: 'flex',
                  gap: '1rem',
                  width: '100%',
                  flexDirection: 'column',
                }}
                key={`${entry.id}-${index}`}
              >
                <UserEntry user={entry} />
                {index < team.user_count - 1 && (
                  <Divider
                    orientation='horizontal'
                    sx={{ color: theme.palette.semiBlack.main }}
                  />
                )}
              </Box>
            ))}
          </Box>
        </Box>
      )}
    </>
  );
};
